define('all/flushcommunicationbar',['jquery'], function($) {
	'use strict';
	function flushCommunicationBar() {
		$.post('/pp?flow=FlushCommunicationBar');
	}

	var flushcommunicationbar = {
		flushCommunicationBar: flushCommunicationBar
	};

	return flushcommunicationbar;
});

